export default __webpack_public_path__ + "static/media/Pizzas.24eeb1f8.jpg";